<script setup lang="ts">
import { labels } from '@/appdata/labels'

defineProps([ 'visible' ])
</script>

<template>
  <div v-if="visible" id="application-loader">
    <div class="d-flex flex-column flex-fill justify-content-center h-100">
      <div class="loader-content p-4">
        <div class="loading-indicator text-center my-3 mx-auto">
          <span class="fa-light fa-fw fa-3x fa-loader fa-spin"></span>
        </div>
        <p class=" loading-label h5 text-center fw-bold text-uppercase my-3">
          {{ labels.userLoggingIn }}
        </p>
      </div>
    </div>
  </div>
</template>
